<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import afiliacionSistemaRiesgosAPI from "@/services/standards/afiliacionSistemaRiesgos/afiliacionSistemaRiesgosAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import procedimientosAPI from "../../../services/standards/procedimientos/procedimientosAPI";
import procedureDocumentAPI from "../../../services/standards/procedimientos/procedureDocumentAPI";
import ProcedimientosPagination from "../../../components/standard/procedimientos/ProcedimientosPagination.vue";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    Multiselect,
    ProcedimientosPagination,
  },
  data() {
    return {
      title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
          active: true,
        },
      ],
      lista: [],
      deleteCount: 0,
      file: null,

      afiliacion: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      procedimientos: {
        security_standards_id: null,
        high_risk_tasks_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      afiliacionContratista: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      trainingList: [],
      employee: [],

      submitted: false,
      search: '',

      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,

      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      segurity: [],
      risk: [],

      form_submitting: false,

      item: null,
      selected: [],
      allSelected: false,
      userIds: [],
      itemStatus: "No cumplido",

      itemData: null,

      optionss: ["Vuex", "Vue", "Vuelidate", "Vue-Multiselect", "Vue-Router"],

      // Subida libre de documentos propios de la empresa (4.2.3)
      ownDoc: { name: null, description: null },
      ownFile: null,
      ownDocs: [],
      ownDocSubmitting: false,
    };
  },
  validations: {
    procedimientos: {
      high_risk_tasks_id: {
        required,
      },
      security_standards_id: {
        required,
      },
    },
  },

  methods: {

    fetch() {
      this.$refs.paginator.query();
    },

    selectAll: function () {
      this.userIds = [];

      if (this.allSelected) {
        for (user in this.employee) {
          this.userIds.push(this.employee[user].id.toString());
        }
      }
    },
    select: function () {
      this.allSelected = false;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(47)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    save() {
      this.submitted = true;
      this.loading1 = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form_submitting = true;
        procedimientosAPI
          .save(this.procedimientos)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 47,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false;
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 47)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 47,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Programa para trabajo en alturas.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print2() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Procedimiento trabajo en esp confinados.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print3() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Procedimiento de seguridad para trabajos en caliente.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print4() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Procedimiento de energías peligrosas.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print5() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Procedimiento de manejo de sustancias químicas.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print6() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Estandar Seguridad Soldadura.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print7() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Estandar Seguridad herramientas.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print8() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Estandar Seguridad  maquinaria y equipos.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print9() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/901285179/Documentos-descargar-procedimientos-evidencia/Estandar Seguridad ManipulacionCargas.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      procedimientosAPI
        .getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getContratistas() {
      afiliacionSistemaRiesgosAPI
        .getContratistas(this.companyID)
        .then((response) => {
          this.trainingList = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getEmpleados() {
      afiliacionSistemaRiesgosAPI
        .getEmpleados(this.companyID)
        .then((response) => {
          this.employee = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getR() {
      procedimientosAPI
        .getListR()
        .then((response) => {
          this.risk = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getS() {
      procedimientosAPI
        .getListS()
        .then((response) => {
          this.segurity = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    // ── Documentos propios (subida libre) ──
    onOwnFile(e) {
      this.ownFile = (e.target.files && e.target.files[0]) || null;
    },
    getOwnDocs() {
      procedureDocumentAPI.getAll(this.companyID)
        .then((r) => { this.ownDocs = (r && r.data && r.data.data) ? r.data.data : []; })
        .catch((err) => console.log(err));
    },
    async saveOwnDoc() {
      if (!this.ownDoc.name || !this.ownFile) {
        Swal.fire({ title: "Atención", text: "Indica un nombre y selecciona un archivo.", icon: "warning" });
        return;
      }
      this.ownDocSubmitting = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const nit = this.company || this.$store.getters["company/getCompany"].nit;
        const path = `${base}/${nit}/4.2.3/propios/${Date.now()}_${this.ownFile.name}`;
        const ok = await uploadDocument(path, this.ownFile);
        if (!ok) throw new Error("upload");
        await procedureDocumentAPI.save({
          companies_id: this.companyID,
          name: this.ownDoc.name,
          description: this.ownDoc.description,
          file: `${process.env.VUE_APP_BUCKET}/${path}`,
        });
        newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 47, status: "Pendiente" }).catch(() => {});
        this.ownDoc = { name: null, description: null };
        this.ownFile = null;
        if (this.$refs.ownFile) this.$refs.ownFile.value = null;
        this.getOwnDocs();
        Swal.fire({ title: "¡Éxito!", text: "Documento cargado.", icon: "success", timer: 1400, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar el documento.", "error");
      } finally {
        this.ownDocSubmitting = false;
      }
    },
    deleteOwnDoc(id) {
      Swal.fire({
        title: "¿Eliminar documento?", icon: "warning", showCancelButton: true,
        confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        procedureDocumentAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminado", icon: "success", timer: 1200, showConfirmButton: false });
          this.getOwnDocs();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },

    goBack() {
      this.$router.go(-1);
    },

    deleteProcedimientos(id) {
      procedimientosAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 47,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getContratistas();
    this.getEmpleados();
    this.getList();
    this.getR();
    this.getS();
    this.getOwnDocs();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe contar con procedimientos, instructivos y
                      fichas técnicas de seguridad y salud en el trabajo, para
                      controlar los posibles accidentes derivados de la
                      realización de actividades o tareas peligrosas.
                    </p>
                    <p class="text-justify">
                      En este ítem la empresa podrá descargar los diferentes
                      programas, procedimientos y estándares de seguridad, los
                      cuales pueden ser adaptados e implementados en la empresa.
                    </p>
                    <p class="text-justify">
                      Estos documentos deben ser entregados a los colaboradores,
                      garantizando su conocimiento y aplicación.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0"></div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-12"></div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Tareas de alto riesgo:" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="procedimientos.high_risk_tasks_id" :class="{
                        'is-invalid':
                          $v.procedimientos.high_risk_tasks_id.$error &&
                          submitted,
                      }">
                      <b-form-select-option v-for="dato in risk" :key="dato.id" :value="dato.id">
                        {{ dato.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.procedimientos.high_risk_tasks_id.$error
                    ">
                      <small v-if="!$v.procedimientos.high_risk_tasks_id.required" class="text-danger">
                        <b>Seleccione una opción</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Estándares de seguridad:" label-for="theme">
                    <b-form-select :class="{
                      'is-invalid':
                        $v.procedimientos.high_risk_tasks_id.$error &&
                        submitted,
                    }" :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="procedimientos.security_standards_id">
                      <b-form-select-option v-for="data in segurity" :key="data.id" :value="data.id">
                        {{ data.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted &&
                      $v.procedimientos.security_standards_id.$error
                    ">
                      <small v-if="!$v.procedimientos.security_standards_id.required" class="text-danger">
                        <b>Seleccione una opción</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">
                                Tareas de alto riesgo
                              </th>
                              <th class="text-center align-middle">
                                Descargar archivo
                              </th>
                              <th class="text-center align-middle">
                                Estandares de seguridad
                              </th>
                              <th class="text-center align-middle">
                                Descargar archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.risk_name }}
                              </td>
                              <td class="text-center align-middle">
                                <button v-if="dato.risk_name === 'Energías peligrosas'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print4">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                                <button v-else-if="dato.risk_name ===
                                  'Manejo de sustancias químicas'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print5">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                                <button v-else-if="dato.risk_name === 'Trabajo en alturas'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>

                                <button v-else-if="dato.risk_name ===
                                  'Trabajo en espacios confinados'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print2">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                                <button v-else-if="dato.risk_name === 'Trabajos en caliente'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print3">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.standard_name }}
                              </td>

                              <td class="text-center align-middle">
                                <button v-if="dato.standard_name ===
                                  'Labores con soldadura'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print6">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                                <button v-else-if="dato.standard_name === 'Manejo de cargas'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print9">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                                <button v-else-if="dato.standard_name ===
                                  'Manejo de herramientas'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print7">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>

                                <button v-else-if="dato.standard_name ===
                                  'Operación segura de equipos'
                                " :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="print8">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/procedimientos-evidencia/${dato.id}`,
                                      }">
                                      Subir archivos</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteProcedimientos(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <ProcedimientosPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- ── Documentos propios de la empresa (subida libre) ── -->
        <div v-if="!loading1" class="card">
          <div class="card-body">
            <h5 class="mb-1">Documentos propios de la empresa</h5>
            <p class="text-muted small">
              Sube tus propios procedimientos, instructivos, fichas técnicas o protocolos (sin depender de los
              catálogos anteriores).
            </p>
            <div class="form-row align-items-end">
              <b-form-group class="col-md-4 px-2" label="Nombre del documento">
                <b-form-input v-model="ownDoc.name" :disabled="!getRole('Crear') || !allowAccess()" size="sm"
                  placeholder="Ej: Procedimiento de bloqueo y etiquetado" />
              </b-form-group>
              <b-form-group class="col-md-4 px-2" label="Descripción (opcional)">
                <b-form-input v-model="ownDoc.description" :disabled="!getRole('Crear') || !allowAccess()" size="sm" />
              </b-form-group>
              <b-form-group class="col-md-3 px-2" label="Archivo">
                <b-form-file ref="ownFile" :disabled="!getRole('Crear') || !allowAccess()" browse-text="Buscar"
                  placeholder="Selecciona un archivo..." @change="onOwnFile"
                  accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,image/*" size="sm" />
              </b-form-group>
              <div class="col-md-1 px-2 pb-2">
                <button type="button" class="btn btn-primary btn-sm btn-block"
                  :disabled="ownDocSubmitting || !getRole('Crear') || !allowAccess()" @click="saveOwnDoc">
                  {{ ownDocSubmitting ? '...' : 'Subir' }}
                </button>
              </div>
            </div>

            <div class="table-responsive mt-2" v-if="getRole('Consultar') || !allowAccess()">
              <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                <thead>
                  <tr>
                    <th class="text-center align-middle">Fecha</th>
                    <th class="text-center align-middle">Nombre</th>
                    <th class="text-center align-middle">Descripción</th>
                    <th class="text-center align-middle">Descargar</th>
                    <th class="text-center align-middle">Acciones</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-if="!ownDocs.length"><td colspan="5" class="text-center text-muted">No hay documentos propios cargados.</td></tr>
                  <tr v-for="doc in ownDocs" :key="doc.id">
                    <td class="text-center align-middle">{{ dateConvert(doc.created_at) }}</td>
                    <td class="text-center align-middle">{{ doc.name }}</td>
                    <td class="text-center align-middle">{{ doc.description }}</td>
                    <td class="text-center align-middle">
                      <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                        type="button" @click="gotoDigitalOcean(doc.file)"><i class="mdi mdi-cloud-download"></i></button>
                    </td>
                    <td class="text-center align-middle">
                      <button :disabled="!getRole('Eliminar') || !allowAccess()" class="btn btn-outline-danger btn-sm py-0"
                        type="button" @click="deleteOwnDoc(doc.id)"><i class="mdi mdi-trash-can"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
